import React, { Component, Fragment } from 'react';
import StepElement from '../StepElement';
import stepImg1 from '~/static/images/domofon/meeting/step1.svg';
import stepImg2 from '~/static/images/domofon/meeting/step2.svg';
import stepImg3 from '~/static/images/domofon/meeting/step3.svg';
import stepImg4 from '~/static/images/domofon/meeting/step4.svg';
import stepImg5 from '~/static/images/domofon/meeting/step5.svg';
import stepImg6 from '~/static/images/domofon/meeting/step6.svg';
import stepImg7 from '~/static/images/domofon/meeting/step7.svg';
import stepImg8 from '~/static/images/domofon/meeting/step8.svg';
import DashBlock from '../DashBlock';
import { Wrapper, StepsBlock, Title, Text, BlockTitle } from './styled';
import CallToActionBlock from '~/src/components/sections/CallToActionBlock';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';

const itemsCallToActionText = [
    '<a href="/static/files/message.pdf" target="_blank">Сообщение</a>.',
    '<a href="/static/files/bulletin.pdf" target="_blank">Бюллетень</a>.',
    '<a href="/static/files/registration_sheets.pdf" target="_blank">Листы регистрации</a>.',
    '<a href="/static/files/decision.pdf" target="_blank">Решение</a>.',
    '<a href="/static/files/protocol.pdf" target="_blank">Протокол</a>.',
];

class StepsGroup extends Component {
    render() {
        return (
            <Wrapper>
                <Title> Как установить домофон Дом.ру в своем подъезде </Title>
                <Text> Убедитесь, что в вашем доме не менее 50 квартир на подъезд. Если так и есть — можно проводить общее собрание собственников жилья.</Text>
                <StepsBlock>
                    <BlockTitle>Подготовка собрания</BlockTitle>
                    <StepElement
                        step={1}
                        img={stepImg1}
                        title='Станьте инициатором ОСС'
                        text='Инициатором собрания может выступить любой собственник помещения. Инициируйте проведение ОСС сами или найдите желающего среди соседей по дому.' />
                    <DashBlock top={20} />
                    <StepElement
                        shift
                        step={2}
                        img={stepImg2}
                        title='Подготовьте все необходимое для проведения собрания'
                        text='Обсудите с менеджером Дом.ру размер абонентской платы для вашего дома. Подготовьте текст объявления для собственников. Напишите, когда и где будет проходить собрание.' />
                    <DashBlock right />
                    <StepElement
                        step={3}
                        img={stepImg3}
                        title='Уведомите собственников помещений'
                        text='Все собственники должны быть уведомлены за 10 дней до собрания. Разместите объявление на информационном стенде.' />
                </StepsBlock>
                <StepsBlock>
                    <BlockTitle>Проведение собрания</BlockTitle>
                    <StepElement
                        step={4}
                        img={stepImg4}
                        title='Подготовьте все необходимое для голосования'
                        text='Выберите председателя, секретаря и членов счетной комиссии. Напечатайте нужное количество бюллетеней для голосования. Внесите в бюллетень дату окончания ОСС.' />
                    <DashBlock />
                    <StepElement
                        shift
                        step={5}
                        img={stepImg5}
                        title='Вручите бюллетень собственникам'
                        text='Собрание может проводиться как в очной, так и очно-заочной форме. Это значит, что проголосовать собственники могут просто вложив заполненный бюллетень в почтовый ящик.' />
                    <DashBlock right />
                    <StepElement
                        step={6}
                        img={stepImg6}
                        title='Подведите итоги голосования'
                        text='Передайте заполненные бюллетени председателю ОСС для подсчета голосов счетной комиссией.' />
                </StepsBlock>
                <StepsBlock>
                    <BlockTitle>Результаты собрания</BlockTitle>
                    <StepElement
                        step={7}
                        img={stepImg7}
                        title='Оформите протокол собрания'
                        text='Убедитесь, что собрание проведено при наличии кворума. Внесите данные, полученные из бюллетеней, в протокол. Заверьте подписями председателя и секретаря ОСС.' />
                    <DashBlock />
                    <StepElement
                        shift
                        step={8}
                        img={stepImg8}
                        title='Уведомите собственников о принятых решениях'
                        text='Сообщите соседям о принятых решениях в течении 10 дней. Разместите объявление на информационном стенде.' />
                    <GridContainer style={{ 'width' : 'auto' }}>
                        <CallToActionBlock
                            title={<Fragment>Подключить <span>домофон</span></Fragment>}
                            rightTitle='Скачайте бланки документов, рекомендованные для проведения собрания'
                            itemsCallToActionText={itemsCallToActionText}
                            productId={'75'}
                        />
                    </GridContainer>
                </StepsBlock>
            </Wrapper>
        );
    }
}

export default StepsGroup;
